/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown> }} Sanction_Baseline_HintInputs */



/**
* | output |
* | --- |
* | "Baseline penalty: {level}" |
*
* @param {Sanction_Baseline_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_baseline_hint = /** @type {((inputs: Sanction_Baseline_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Baseline_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Pénalité de base : ${i?.level}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Penalización base: ${i?.level}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Penalidade base: ${i?.level}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Penalità base: ${i?.level}`)
	return /** @type {LocalizedString} */ (`Baseline penalty: ${i?.level}`)
});